"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationLinks = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = require("@emotion/react");
const react_2 = require("react");
const router_1 = require("@reach/router");
const semantic_ui_react_1 = require("semantic-ui-react");
const react_i18next_1 = require("react-i18next");
const account_features_1 = require("../../account-features");
const util_1 = require("./util");
const context_1 = require("./context");
const nav_definitions_1 = require("./nav-definitions");
const layout_1 = require("../layout");
const NavigationLinks = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { womOrigin, womUrlPrefix, accountSlug, userType, accountFeatures } = (0, context_1.useWomUrlInfo)();
    const navigationItems = (0, nav_definitions_1.getNavigationDefinitions)(womOrigin, accountSlug, t);
    const permissions = [
        userType,
        accountFeatures[account_features_1.ACCOUNT_FEATURES.skuCreateEdit] ? "SKU_CREATE" : undefined,
        accountFeatures[account_features_1.ACCOUNT_FEATURES.printStationManagement] ? "NAV_PRINT_STATION" : undefined,
        accountFeatures[account_features_1.ACCOUNT_FEATURES.callbackManagement] ? "NAV_CALLBACK" : undefined,
    ].filter(util_1.isString);
    return ((0, jsx_runtime_1.jsx)("nav", Object.assign({ css: navCss, className: "hud-navigation-links" }, { children: navigationItems.map(({ id, title, link, icon, urlMatches, isActive, subitems }, idx) => ((0, jsx_runtime_1.jsx)(NavigationItemLink, { id: id, title: title, link: link, icon: icon, urlMatches: urlMatches, isActive: isActive, isRoot: true, subitems: subitems, permissions: permissions, womUrlPrefix: womUrlPrefix }, link || idx))) })));
};
exports.NavigationLinks = NavigationLinks;
const NavigationItemLink = ({ id, title, icon, link, subitems, isRoot = false, permissions, tabIndex = 0, urlMatches, isActive, womUrlPrefix, }) => {
    const linkBuilder = (0, util_1.useNavigationLinkBuilder)();
    const subitemHiddenContainerRef = (0, react_2.useRef)(null);
    const [subitemsHeight, setSubitemsHeight] = (0, react_2.useState)(0);
    const [selected, setSelected] = (0, context_1.useNavigationSelection)();
    const [, setLayoutState] = (0, layout_1.useLayoutContext)();
    const loc = (0, router_1.useLocation)();
    const currentPath = (loc.pathname + loc.search).replace(`/${womUrlPrefix}`, "/WOM");
    const hasSubitems = Boolean(subitems === null || subitems === void 0 ? void 0 : subitems.length);
    const isOpen = isRoot && hasSubitems && selected === id;
    const isSelected = urlMatches.some(reOrPredicate => typeof reOrPredicate === "function"
        ? reOrPredicate(currentPath)
        : reOrPredicate.test(currentPath));
    const { href: url, onClick: handleLinkClick } = linkBuilder(link || "/WOM/", () => {
        if (isRoot) {
            if (selected !== id) {
                setSelected(id);
            }
            else if (selected === id) {
                setSelected("");
            }
            if (hasSubitems) {
                return false;
            }
        }
        setLayoutState(s => {
            if (s.navigationState === "mobileViewOpen") {
                return Object.assign(Object.assign({}, s), { navigationState: "mobileViewClosed" });
            }
            return s;
        });
    });
    // TODO: make sure ref is always updated, maybe pass it to the effect
    (0, react_2.useEffect)(() => {
        var _a;
        const { height } = ((_a = subitemHiddenContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || { height: 0 };
        setSubitemsHeight(Math.ceil(height));
    }, []);
    return (0, util_1.shouldDisplay)(permissions, isActive) ? ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "navigation-item" }, { children: [(0, jsx_runtime_1.jsxs)("a", Object.assign({ href: link ? url : "/", onClick: handleLinkClick, className: (0, clsx_1.default)({
                    expanded: isOpen,
                    selected: isSelected,
                    "has-subitems": Boolean(subitems),
                }), "aria-expanded": hasSubitems ? isOpen : undefined, title: title, "aria-label": title, tabIndex: tabIndex }, { children: [icon && (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: icon }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "nav-item-title" }, { children: title }))] })), hasSubitems && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "navigation-subitems", style: { "--height": `${subitemsHeight}px` } }, { children: subitems === null || subitems === void 0 ? void 0 : subitems.map(item => ((0, jsx_runtime_1.jsx)(NavigationItemLink, { id: item.id, title: item.title, link: item.link, icon: item.icon, urlMatches: item.urlMatches, isActive: item.isActive, subitems: item.subitems, permissions: permissions, tabIndex: isOpen ? 0 : -1, womUrlPrefix: womUrlPrefix }, item.id))) }))), hasSubitems && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "hidden-subitems", "aria-hidden": true, tabIndex: -1 }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ ref: subitemHiddenContainerRef }, { children: subitems === null || subitems === void 0 ? void 0 : subitems.map(item => ((0, jsx_runtime_1.jsx)(NavigationItemLink, { id: item.id, title: item.title, link: item.link, icon: item.icon, urlMatches: item.urlMatches, isActive: item.isActive, subitems: item.subitems, permissions: permissions, tabIndex: -1, womUrlPrefix: womUrlPrefix }, item.id))) })) })))] }))) : null;
};
const navCss = (0, react_1.css) `
  min-width: 250px;
  font-size: 14px;
  padding: 0.715em;
  padding-right: 0.32em;

  .navigation-item {
    & > .navigation-subitems {
      max-height: 0;
      overflow: hidden;

      transition: padding-bottom 100ms ease-out, max-height 300ms ease-out;

      & .navigation-item a {
        padding-left: 2em;
      }
    }
    & > .hidden-subitems {
      height: 0;
      visibility: hidden;
    }

    > a {
      display: block;
      position: relative;
      line-height: 1;
      padding: 0.643em;
      transition: 180ms background-color ease;
      text-decoration: none;
      cursor: default;
      border-radius: 0.57em;
      white-space: nowrap;
      background-color: rgba(255, 255, 255, 0);
      cursor: pointer;
      outline-offset: -2px;

      &:hover {
        background-color: rgba(255, 255, 255, 0.25);
      }

      & .icon {
        font-size: 12px;
        margin-right: 0.715em;
        color: rgba(255, 255, 255, 0.5);
      }

      &.has-subitems::after {
        display: block;
        content: "";
        position: absolute;

        top: 50%;
        right: 1.2em;
        width: 0.5em;
        height: 0.5em;

        border: 0 solid rgba(255, 255, 255, 0.5);
        border-width: 0 2px 2px 0;
        transform: rotate(45deg) translateY(-50%);
        transform-origin: right;
      }
      &.expanded {
        &.has-subitems {
          &::after {
            border-color: #fff;
          }
        }

        & + .navigation-subitems {
          margin-bottom: 1em;
          max-height: calc(var(--height) + 1.4rem);
        }
      }

      & .nav-item-title {
        position: relative;
        display: inline-block;
      }
      &.selected {
        .icon {
          color: #fff;
        }
        &:not(.has-subitems) {
          color: #fff;
        }
        &.has-subitems {
          font-weight: 600;

          &.selected {
            color: #fff;
          }
        }
      }
    }
  }
`;
